module.exports = __webpack_public_path__ + "img/p1-pic@2x.ae1f55f7.jpg";